// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"293":"component---src-pages-index-js","453":"d7eeaac4"}[chunkId] || chunkId) + "-" + {"70":"d1276a26c9582a5097e6","242":"71626ea14d812b075ba2","293":"43393a21a5f67e283f1c","453":"349b74ad6cb8c34b6a02","556":"4cce8d1f4034510aace5"}[chunkId] + ".js";
};